import React from 'react'
import { cartMobx, storeMobx } from 'restaurant'
import { timePickMobx, deliveryMobx } from '@mobxStore'
import TimePickController from '@ctrls/timePickController'
import { observer } from 'mobx-react'
import './index.scss'

interface ITimePickbar {
  index?: number;
  type: 'order' | 'product';
  scene?: 'default' | 'swapBuy';
  cartItem?: IViewCartItem;
}

const TimePickBar: React.FC<ITimePickbar> = ({ index, type, scene = 'default', cartItem }) => {
  if (!storeMobx.info.isMobileBookingOrder) {
    return null
  }

  // 订单不能预约不显示
  if (type === 'order') {
    if (!timePickMobx.timePickList.length || Config.codeType !== 'brand') {
      return null
    }
    if (timePickMobx.notOrderPick) {
      return null
    }
  } else if (type === 'product') {
    if (!cartItem?.startTime) {
      return null
    }
  }

  /** 堂食送餐制，不需要预约 */
  if (!timePickMobx.canBookingTime) {
    return null
  }

  const handleSelectTime = () => {
    if (cartMobx.info.eatType === 'delivery' && !deliveryMobx.address) {
      return
    }
    if (type === 'order') {
      TimePickController.handleAppointment('order', {
        callback: () => {
          cartMobx.setExpressList()
        }
      })
    } else if (type === 'product') {
      TimePickController.handleAppointment('product', {
        no: cartItem.productNo,
        startTime: cartItem.startTime,
        pickTimeRange: cartItem.pickTimeRange,
        callback: () => {
          const { startTime, pickTimeRange } = timePickMobx.productReserveInfo
          if (scene === 'swapBuy') {
            cartMobx.setSwapBuyCartItemStartTime(cartItem, startTime, pickTimeRange)
          } else {
            cartMobx.setCartItemStartTime(cartItem, startTime, pickTimeRange)
          }
        }
      })
    }
  }

  return (
    <div data-cypid={`checkTimePick_pk_${cartItem?.pk}`} className={`checkout-timepick ${type} ${scene === 'swapBuy' ? 'tag' : ''} ${index === 0 && timePickMobx.notOrderPick ? 'noline' : ''}`} onClick={handleSelectTime}>
      {
        scene === 'swapBuy' ? (
          <>
            {i18n.t(`newCart.${cartMobx.info.eatType === 'delivery' ? 'timeFor_delivery' : 'timeFor_pickup'}`, { time: timePickMobx.getTimeText(type, type === 'product' ? { startTime: cartItem?.startTime, pickTimeRange: cartItem?.pickTimeRange } : undefined) })}
            <i className='iconfont icon-chevron-right' />
          </>
        ) : (
          <>
            {i18n.t(`newCart.${cartMobx.info?.eatType}time`)}
            <span className={cartMobx.info?.eatType === 'delivery' && !deliveryMobx.address ? 'disabled' : ''}>{cartMobx.info?.eatType === 'delivery' && !deliveryMobx.address ? timePickMobx.getTimeText(type, type === 'product' ? { startTime: cartItem?.startTime, pickTimeRange: cartItem?.pickTimeRange } : undefined) : i18n.t(`newCart.timeFor_${cartMobx.info.eatType}2`, { time: timePickMobx.getTimeText(type, type === 'product' ? { startTime: cartItem?.startTime, pickTimeRange: cartItem?.pickTimeRange } : undefined) })}</span>
            <i className='iconfont icon-chevron-right' />
          </>
        )
      }
    </div>
  )
}

export default observer(TimePickBar)
